export const chainScroll = {
  data() {
    return {
      scrollSpeed: 700,
      isScrolling: false,
      scrollAnimId: null,
    };
  },
  methods: {
    scroll(x) {
      if (this.isScrolling) return;
      this.isScrolling = true;
      const container = this.$refs.container;
      if (!container) return;
      container.scrollBy({ left: x, behavior: "smooth" });
      setTimeout(() => {
        this.isScrolling = false;
      }, Math.abs(x) / 2);
    },
    onWheel(event) {
      const container = this.$refs.container;
      if (!container) return;
      const delta = event.deltaY || event.deltaX;
      if (!delta) return;
      container.scrollLeft += delta;
    },
    // scrollLeft that puts the tile at `index` into the 2nd position -- where
    // the first tile starts unscrolled, i.e. after the strip's leading pad
    // (room for the previous / purchased offer).
    targetScrollFor(index) {
      const node = document.getElementById("chain-tile-" + index);
      const first = document.getElementById("chain-tile-0");
      if (!node || !first) return 0;
      return Math.max(0, node.offsetLeft - first.offsetLeft);
    },
    centerScrollFor(index) {
      const node = document.getElementById("chain-tile-" + index);
      const container = this.$refs.container;
      if (!node || !container) return 0;
      return Math.max(
        0,
        node.offsetLeft + node.offsetWidth / 2 - container.clientWidth / 2
      );
    },
    animateScrollTo(to, duration = 500, onDone) {
      const container = this.$refs.container;
      if (!container) {
        if (onDone) onDone();
        return;
      }
      if (this.scrollAnimId) cancelAnimationFrame(this.scrollAnimId);
      const start = container.scrollLeft;
      const change = to - start;
      if (!change) {
        container.scrollLeft = to;
        if (onDone) onDone();
        return;
      }
      let startTs = null;
      const ease = (t) => 1 - Math.pow(1 - t, 3); // easeOutCubic
      const step = (ts) => {
        if (startTs === null) startTs = ts;
        const p = Math.min(1, (ts - startTs) / duration);
        container.scrollLeft = start + change * ease(p);
        if (p < 1) this.scrollAnimId = requestAnimationFrame(step);
        else if (onDone) onDone();
      };
      this.scrollAnimId = requestAnimationFrame(step);
    },
    scrollToCurrent(
      onDone,
      fromIndex = 0,
      holdMs = 0,
      centerStart = false,
      onHoldStart = null,
      durationMs = 1600,
      onSlideStart = null
    ) {
      const container = this.$refs.container;
      if (!container) {
        if (onDone) onDone();
        return;
      }
      container.scrollLeft = centerStart
        ? this.centerScrollFor(fromIndex)
        : this.targetScrollFor(fromIndex);
      if (onHoldStart) onHoldStart();
      const target = this.targetScrollFor(this.currentIndex);
      if (target === container.scrollLeft) {
        if (onDone) onDone();
        return;
      }
      const run = () => {
        if (onSlideStart) onSlideStart();
        this.animateScrollTo(target, durationMs, onDone);
      };
      if (holdMs > 0) setTimeout(run, holdMs);
      else requestAnimationFrame(run);
    },
    scheduleScrollToCurrent(
      attempt = 0,
      onDone,
      fromIndex = 0,
      holdMs = 0,
      centerStart = false,
      onHoldStart = null,
      durationMs = 1600,
      onSlideStart = null
    ) {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          const container = this.$refs.container;
          // The modal fades in: until it's laid out, clientWidth is 0 and the
          // scroll math is wrong. Retry until the container is measurable.
          if ((!container || container.clientWidth === 0) && attempt < 30) {
            this.scheduleScrollToCurrent(
              attempt + 1,
              onDone,
              fromIndex,
              holdMs,
              centerStart,
              onHoldStart,
              durationMs,
              onSlideStart
            );
            return;
          }
          this.scrollToCurrent(
            onDone,
            fromIndex,
            holdMs,
            centerStart,
            onHoldStart,
            durationMs,
            onSlideStart
          );
        });
      });
    },
  },
};
